import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const LogoSlider = () => {
  const settings = {
    dots: false, // Disable dots navigation
    infinite: true, // Infinite scrolling
    speed: 500, // Transition speed
    slidesToShow: 5, // Number of logos to show at once
    slidesToScroll: 1, // Number of logos to scroll at a time
    autoplay: true, // Enable auto slide
    autoplaySpeed: 2000, // Auto slide every 2 seconds
    arrows: false, // Remove arrows for clean design
    responsive: [
      {
        breakpoint: 1024, // Settings for screens below 1024px
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600, // Settings for screens below 600px
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // Settings for screens below 480px
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // Example company logo URLs
  const logos = [
    "/img/Corporate logos/Corporate Customer Logo on Website-01.jpg",
    "/img/Corporate logos/Corporate Customer Logo on Website-02.jpg",
    "/img/Corporate logos/Corporate Customer Logo on Website-03.jpg",
    "/img/Corporate logos/Corporate Customer Logo on Website-04.jpg",
    "/img/Corporate logos/Corporate Customer Logo on Website-05.jpg",
    "/img/Corporate logos/Corporate Customer Logo on Website-06.jpg",
    "/img/Corporate logos/Corporate Customer Logo on Website-07.jpg",
    "/img/Corporate logos/Corporate Customer Logo on Website-08.jpg",
    "/img/Corporate logos/Corporate Customer Logo on Website-09.jpg",
    "/img/Corporate logos/Corporate Customer Logo on Website-10.jpg",
    "/img/Corporate logos/Corporate Customer Logo on Website-11.jpg",
    "/img/Corporate logos/Corporate Customer Logo on Website-12.jpg",
    "/img/Corporate logos/Corporate Customer Logo on Website-13.jpg",
    "/img/Corporate logos/Corporate Customer Logo on Website-14.jpg",
    "/img/Corporate logos/Corporate Customer Logo on Website-15.jpg",
    "/img/Corporate logos/Corporate Customer Logo on Website-16.jpg",
  
   
  ];

  return (
    <div className="logo-slider py-4">
      <Slider {...settings}>
        {logos.map((logo, index) => (
          <div key={index} className="logo-slide">
            <img src={logo} alt={`Logo ${index + 1}`} style={{ maxWidth: "100%", height: "auto" }} />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default LogoSlider;
